import Header from '../../components/Header/Header';
import LogoSection from '../../components/LogoSection/LogoSection';
import AboutUs from '../../components/AboutUs/AboutUs';

import WhatsappFloatingButton from '../../components/WhatsappFloatingButton/WhatsappFloatingButton';
import OrderTutorial from '../../components/OrderTutorial/OrderTutorial';
import Footer from '../../components/Footer/Footer';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Video from '../../components/Video/Video';
import WhyChooseUs from '../../components/WhyChooseUs/WhyChooseUs';
import Hero from '../../components/Hero/Hero';
import { VideoWrapper } from './Home.styled';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        // Delay to ensure DOM is ready
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);
  
  return (
    <>
      <Header />
      <VideoWrapper>
        <Video videoId="PJgQ5EHZn4k"  />
      </VideoWrapper>
      <Hero />
      <AboutUs />
      <WhyChooseUs />
      <OrderTutorial />
      <Footer />
      <WhatsappFloatingButton />
    </>
  );
}

export default Home;
